import { Component, Input } from '@angular/core';
import { FeedbackComponentConfig, FeedbackStage } from '../types';

@Component({
  selector: 'claims-athome-myaccount-feedback-component',
  templateUrl: './feedback-component.component.html',
  styleUrls: ['./feedback-component.component.scss'],
})
export class FeedbackComponentComponent {
  @Input() feedbackConfig: FeedbackComponentConfig;

  @Input() handlerWhenFormSubmitted: (
    feedbackConfig: FeedbackComponentConfig,
    isComplete: boolean
  ) => void;

  showOptionError = false;

  submitFeedback(): void {
    const selectedValue =
      this.feedbackConfig.selectedValue[this.feedbackConfig.activeStage];
    const { freeTextInput, maxCharCount } =
      this.feedbackConfig.stages[this.feedbackConfig.activeStage];
    const nextStage = this.feedbackConfig.activeStage + 1;

    const userNotEnteredValue = freeTextInput && selectedValue === '';
    const userExceededCharLimit =
      freeTextInput && (selectedValue || '').length > (maxCharCount ?? 200);
    if (!selectedValue || userNotEnteredValue || userExceededCharLimit) {
      this.showOptionError = true;
      return;
    }

    this.showOptionError = false;

    const moveOntoNextStage =
      this.feedbackConfig.stages[nextStage]?.activeWhenPreviousValueIs ===
      selectedValue;
    if (this.handlerWhenFormSubmitted) {
      this.handlerWhenFormSubmitted(
        this.feedbackConfig,
        moveOntoNextStage === false
      );
    }

    if (moveOntoNextStage) {
      this.feedbackConfig.activeStage = nextStage;
      return;
    }

    this.feedbackConfig.activeStage = this.feedbackConfig.finishFormValue;
  }

  freeTextInput(event: string, textArea: HTMLTextAreaElement): void {
    this.showOptionError = false;
    const { maxCharCount } =
      this.feedbackConfig.stages[this.feedbackConfig.activeStage];
    event = event.substring(0, maxCharCount);
    textArea.value = event;
    this.feedbackConfig.selectedValue[this.feedbackConfig.activeStage] = event;
  }

  get configActiveStage(): FeedbackStage {
    return this.feedbackConfig.stages[this.feedbackConfig.activeStage];
  }
}
